<div class="brand-logo">
    @if (tenantCount > 1) {
        <a [routerLink]="['/main/tenant-selector']"
                routerLinkActive=BusinessObjectStatus.Active>
            <img src="/assets/brand/app-logo-on-dark.svg" alt="logo" height="{{logoHeight}}" />
        </a>
    }
    @if (tenantCount === 1 || tenantCount === 0) {
        <img src="/assets/brand/app-logo-on-dark.svg" alt="logo" height="{{logoHeight}}" />
    }
</div>